import React, { useEffect } from "react";
import { gql } from "@apollo/client";
import { basename } from "env";
import { useAccount, resetAccount } from "@repoflow/components/account";
import { Icon as LoadingIcon } from "@repoflow/components/loading";
import { useMutation } from "@apollo/client";
import { Container, Col, Row, Alert } from "reactstrap";

const MUTATION = gql`
  mutation Logout {
    viewer {
      account {
        auth {
          logout
        }
      }
    }
  }
`;

export default () => {
  const account = useAccount();
  const { domainId } = account.domain

  const [handler] =
    useMutation(MUTATION, {
      refetchQueries: [],
      onCompleted: (data) => {
        resetAccount();
        window.location = `${basename}/auth/login?domainId=${encodeURIComponent(domainId)}`;
      },
      onError: (error) => { },
    });

  useEffect(() => {
    handler();
  }, []);

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          <Alert color="info">
            The account is logging out... <LoadingIcon />
          </Alert>
        </Col>
      </Row>
    </Container>
  );
};
